let config={
    appName:'/net',
    resPre:'http://localhost:9400/lookApi/examination/',
    skin:'teal',
    isDev:false,
    vaptchaId:'5de798b3e62d2b442088be96',//vaptcha的id
    officePre:'https://view.officeapps.live.com/op/view.aspx'
};
if(location.hostname=='120.202.180.67'){//测试环境
    Object.assign(config,{
        appName:'/net',
        resPre:'https://120.202.180.67/fileApi/',
        skin:'teal',
        isDev:true,
        vaptchaId:'5de793ede62d2b442088be8f',//vaptcha的id
        officePre:'https://view.officeapps.live.com/op/view.aspx'
    })
}
if(location.hostname=='10.10.10.156'){//测试环境
    Object.assign(config,{
        appName:'/net',
        resPre:'https://10.10.10.156/fileApi/',
        skin:'teal',
        isDev:true,
        vaptchaId:'5df34d6685504cd2f0bab345',//vaptcha的id
        officePre:'https://view.officeapps.live.com/op/view.aspx'
    })
}
if(location.hostname=='zsb.qcuwh.edu.cn'){//测试环境
  Object.assign(config,{
    appName:'/net',
    resPre:'https://zsb.qcuwh.edu.cn/fileApi/',
    skin:'teal',
    isDev:true,
    vaptchaId:'5df34d6685504cd2f0bab345',//vaptcha的id
    officePre:'https://view.officeapps.live.com/op/view.aspx'
  })
}


export default config;
